export const CURRENT_DATE = new Date()
const NEXT_NINETY_DAY = new Date(new Date().setDate(new Date().getDate() + 90))
const NEXT_THREE_DAY = new Date(new Date().setDate(new Date().getDate() + 3))

export const getCookieExpiration = (placeId: string | number) => {
    // placeId is set when user change location manualy. In this case we store cookie for 90 days
    return placeId ? NEXT_NINETY_DAY : NEXT_THREE_DAY
}
